import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetOrdersRequestSchema,
  TGetOrdersResponseSchema,
} from "./getOrders.schema";

export const getOrders = (axios: IAxiosInstance) => {
  return async (params: TGetOrdersRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetOrdersResponseSchema>
    >(`/api/orders`, {
      params,
    });
    const data = response.data;

    return data;
  };
};
